// Import Elements
import Container from './Container'
import Input from './Input'
import Header from './Header'
import Divider from './Divider'
import File from './File'
import Button from './Button'
import Module from './Module'
import NumberSlider from './NumberSlider'
import Select from './Select'
import PopUp from './PopUp'
import Textarea from './Textarea'
import Checkbox from './Checkbox'
import Number from './Number'
import Group from './Group'

/*import Select from './Select';
import DateRange from './DateRange';

import Button from './Button';
import Range from './Range';




import Date from "./Date";
import DateHour from "./DateHour";
import Image from "./Image";

import Text from "./Text";
import RadioButton from './RadioButton';
import ProductImage from '../components/productImage';
import ProductList from '../components/productList';*/

//Export Elements as default
export default {
  Container,
  Input,
  Header,
  Divider,
  File,
  Button,
  Module,
  NumberSlider,
  Select,
  PopUp,
  Textarea,
  Checkbox,
  Number,
  Group,
  /*
    DateRange,
    
    Button,
    Range,
    Checkbox,
    Textarea,
    
    Date,
    Image,
    ,
    Text,
    DateHour,
    RadioButton,
    ProductImage,
    ProductList*/
}
